import request from './request';

export const fetchWines = () =>
  request({
    method: 'GET',
    url: '/clients/wines',
    protectedRoute: true,
    newApi: true
  });
